export type DocumentLocale = 'tr' | 'en';

export const DOCUMENT_LOCALE_STORAGE_KEY = 'budget_web_lang';

export function normalizeDocumentLocale(
    value: string | null | undefined
): DocumentLocale {
    return value === 'en' ? 'en' : 'tr';
}

export function resolveDocumentLocale(
    searchParams: URLSearchParams
): DocumentLocale {
    const queryLang = searchParams.get('lang');
    if (queryLang) {
        return normalizeDocumentLocale(queryLang);
    }

    try {
        const stored = localStorage.getItem(DOCUMENT_LOCALE_STORAGE_KEY);
        if (stored) {
            return normalizeDocumentLocale(stored);
        }
    } catch {
        // localStorage may be unavailable
    }

    return 'tr';
}

export function persistDocumentLocale(locale: DocumentLocale): void {
    try {
        localStorage.setItem(DOCUMENT_LOCALE_STORAGE_KEY, locale);
    } catch {
        // localStorage may be unavailable
    }
}
